export default __webpack_public_path__ + "static/Bailey-350x350-eaae06115f2bc7c098ba9a424b19f8bd.jpg";